import { motion } from "framer-motion";
import { ListChecks, WifiOff, Share2, ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppProviders";

const icons = [ListChecks, WifiOff, Share2, ShieldCheck];

const ValueProps = () => {
  const { t } = useApp();

  return (
    <section
      id="features"
      data-testid="value-section"
      className="py-24 sm:py-32 border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <p className="font-mono text-sm uppercase tracking-widest text-blue-500">
            {t.value.label}
          </p>
          <h2 className="font-heading mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
            {t.value.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            {t.value.subtitle}
          </p>
        </motion.div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-sm border border-border bg-border sm:grid-cols-2 lg:grid-cols-4">
          {t.value.cards.map((card, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={card.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`value-card-${i}`}
                className="group bg-card p-8 transition-colors duration-200 hover:bg-secondary/50"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-sm border border-blue-600/30 bg-blue-600/10 text-blue-500 transition-colors duration-200 group-hover:bg-blue-600 group-hover:text-white">
                  <Icon className="h-6 w-6" strokeWidth={2} />
                </div>
                <span className="mt-6 inline-block rounded-sm border border-border px-2 py-0.5 font-mono text-xs uppercase tracking-wide text-muted-foreground">
                  {card.tag}
                </span>
                <h3 className="font-heading mt-3 text-xl font-medium tracking-tight">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  {card.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
